import React from "react";
import {cn} from "../utils";

const ReplayIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg fill="none"
         height="512"
         viewBox="0 0 24 24"
         width="512"
         className={cn(className)}
         xmlns="http://www.w3.org/2000/svg">
        <path clipRule="evenodd"
              d="m12 2.75c-5.10863 0-9.25 4.14137-9.25 9.25 0 5.1086 4.14137 9.25 9.25 9.25 5.1086 0 9.25-4.1414 9.25-9.25 0-.4142.3358-.75.75-.75s.75.3358.75.75c0 5.9371-4.8129 10.75-10.75 10.75-5.93706 0-10.75-4.8129-10.75-10.75 0-5.93706 4.81294-10.75 10.75-10.75 3.0231 0 5.7548 1.24849 7.7072 3.25599l.5813-1.74323c.131-.39295.5558-.60527.9487-.47425.393.13102.6053.55579.4743.94873l-1 2.99903c-.0882.26451-.3159.45826-.5911.50303-.2752.04476-.5525-.06685-.72-.28977-1.6889-2.2479-4.375-3.69953-7.4004-3.69953zm-3.75 7.6771c0-1.67266 1.7602-2.76052 3.2562-2.01251l3.1459 1.57295c1.6584.82916 1.6584 3.19576 0 4.02496l-3.1459 1.5729c-1.496.748-3.2562-.3398-3.2562-2.0125zm2.5854-.67087c-.4987-.24934-1.0854.11328-1.0854.67087v3.1458c0 .5576.5867.9202 1.0854.6709l3.1459-1.573c.5528-.2764.5528-1.0652 0-1.3416z"
              fill={color || "currentColor"}
              fillRule="evenodd"
        />
    </svg>
);

export {ReplayIcon};